import { useId, useState } from 'react'
import { Menu, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import CustomButton from '../../../../ui/CustomButton'

const SelectorVinculacionBanco = ({ items, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const id = useId()

  return (
    <>
      <CustomButton
        id={`${id}-button`}
        type='button'
        aria-haspopup='menu'
        aria-expanded={Boolean(anchorEl)}
        aria-controls={anchorEl ? `${id}-menu` : undefined}
        onClick={event => setAnchorEl(event.currentTarget)}
        className='rounded-full flex items-center justify-center text-sm font-sans bg-accent2 text-white'
        title={<>
          Crear Vinculación
          <KeyboardArrowDownIcon fontSize='small' className='ml-1' />
        </>}
      />
      <Menu
        id={`${id}-menu`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ 'aria-labelledby': `${id}-button` }}
        PaperProps={{ sx: { maxHeight: 360, minWidth: 260, borderRadius: 2 } }}
      >
        {items.map(item => (
          <MenuItem
            key={item.id}
            onClick={() => {
              setAnchorEl(null)
              onSelect(item.id)
            }}
            sx={{ fontSize: 12, py: 1.25 }}
          >
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default SelectorVinculacionBanco
